const config = {
    data: {
        price:{},
        meta:{},
        category:{},
        sub_category:{}


    },
    price: {
        price:{}
    },
    isLoaded:false,
    dfd:''
};

export default config;


// WEBPACK FOOTER //
// ./src/config.js